module.exports = __webpack_public_path__ + "img/fi2.b7a759dd.png";